module.exports = __webpack_public_path__ + "img/MET-France_120X35.8fa821c7.png";